import { render, staticRenderFns } from "./MailDashboard.vue?vue&type=template&id=9de2f17a&scoped=true&"
import script from "./MailDashboard.vue?vue&type=script&lang=js&"
export * from "./MailDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MailDashboard.vue?vue&type=style&index=0&id=9de2f17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de2f17a",
  null
  
)

export default component.exports